// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "statics/js/" + ({"177":"home","183":"serve","378":"user","411":"media","697":"news","842":"map","966":"advert"}[chunkId] || chunkId) + "." + {"19":"fff7db2a","66":"055cb1ca","177":"88950e8f","183":"537fa702","378":"9b7ef633","411":"7c63c1e8","697":"8468a48e","842":"f9e22bf5","966":"2a9eb01e","997":"5e0fcdc5"}[chunkId] + ".js";
};